import React, { useState, useEffect } from "react";

//redux
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

//action
import {
  showColor,
  setInitial,
  showTexture,
  setRenderPreview,
} from "../../redux/data/ui/index";

// import { saveModelGif } from "../../redux/data/home/index";

import { setUploadedImage } from "../../redux/data/home";

//icons
import HomeIcon from "./src/HomeIcon";
import DownloadIcon from "./src/DownloadIcon";
import PostIcon from "./src/PostIcon";
import ShopIcon from "./src/ShopIcon";
import VaultIcon from "./src/VaultIcon";
import DeleteIcon from "./src/DeleteIcon";
import ColorIcon from "./src/ColorIcon";
import OptionIcon from "./src/OptionIcon";
import RefreshIcon from "./src/RefreshIcon";
import UploadIcon from "./src/UploadIcon";
import UndoIcon from "./src/UndoIcon";
import RedoIcon from "./src/RedoIcon";

import "./index.scss";

const Design = () => {
  const [option, setoption] = useState(false);

  const [color, setcolor] = useState(false);

  const { renderPreview } = useAppSelector((state) => state.uiState);
  const { gifImage } = useAppSelector((state) => state.appData);
  var element = document.createElement("a");

  useEffect(() => {
    if (gifImage) {
      element.href = gifImage;
      element.download = "image.gif";
    }
  }, [gifImage]);
  const dispatch = useAppDispatch();
  return (
    <div className="container-fluid" id="design">
      <div className="row d-flex justify-content-between mx-0">
        <div className="button-group d-flex">
          <div className="the-button">
            <div className="home rounded-circle">
              <HomeIcon></HomeIcon>
            </div>
            Home
          </div>
          <div className="the-button">
            <div className="home rounded-circle">
              <DownloadIcon />
            </div>
            Post
          </div>
          <div
            className="the-button"
            onClick={() =>
              gifImage
                ? element.click()
                : alert("First click on Order to preview the model")
            }
          >
            <div className="home rounded-circle">
              <PostIcon />
            </div>
            Download
          </div>
        </div>
        <div
          className="shop-btn"
          onClick={() => {
            alert(
              "After the model preview wait for a notification that says preview is ready to be downloaded"
            );
            dispatch(setRenderPreview(!renderPreview));
          }}
        >
          <div className="the-button">
            <div className="home rounded-circle">
              <ShopIcon />
            </div>
            Order
          </div>
        </div>
      </div>
      <div className="row d-flex justify-content-end optional-icons">
        {option && (
          <div className="container-icons">
            <div className="optional-icon">
              <RefreshIcon />
            </div>
            <div className="optional-icon">
              <div></div>
              <UploadIcon />
              <input
                id="image-upload"
                type="file"
                name="file"
                onChange={(e) => {
                  if (e.target.files[0]) {
                    const imageData = e.target.files[0];
                    dispatch(
                      setUploadedImage(window.URL.createObjectURL(imageData))
                    );
                  }
                }}
              />
            </div>
            <div className="optional-icon">
              <UndoIcon />
            </div>
            <div className="optional-icon">
              <RedoIcon />
            </div>
          </div>
        )}
      </div>
      <div className="row d-flex justify-content-between the-nav mx-0">
        <div className="vault rounded-circle">
          <VaultIcon />
        </div>
        <div className="other-functionality d-flex justify-content-between">
          <div className="single-nav-icon">
            <DeleteIcon />
            <div> Delete</div>
          </div>
          <div className="separator-line"></div>
          <div
            className="single-nav-icon"
            onClick={(e: any) => {
              e.preventDefault();
              dispatch(showTexture());
            }}
          >
            <div className="fabric"></div>
            <div>Fabric</div>
          </div>
          <div className="separator-line"></div>
          <div
            className="single-nav-icon"
            onClick={(e: any) => {
              e.preventDefault();
              dispatch(showColor());
              setcolor(!color);
            }}
          >
            <ColorIcon />
            <div>Color</div>
          </div>
          <div className="separator-line"></div>
          <div
            className="single-nav-icon"
            onClick={(e: any) => {
              e.preventDefault();
              setoption(!option);
            }}
          >
            <OptionIcon />
            <div>More</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Design;
